import React from "react";
import { Input } from "antd";
import { TextAreaProps } from "antd/es/input";
import { useTranslation } from "react-i18next";

const { TextArea } = Input;

interface IProps extends TextAreaProps
{
  className?: string;
  label?: string;
  classNameDiv?: string;
  required?: boolean;
  optional?: boolean
}

export default function TextAreaUI({
  className,
  label,
  classNameDiv,
  required,
  optional,
  ...res
}: IProps)
{

  const { t } = useTranslation()
  return (
    <div className={`${classNameDiv}`}>
      {label && (
        <p className="mb-2 text-[var(--color-text-select)] text-sm">
          {label}
          {optional && (
            <span className="text-common-line">{` (${t("Optional")})`}</span>
          )}
          {required && <span className="text-common-red500">{` *`}</span>}
        </p>
      )}
      <TextArea
        {...res}
        className={`!border-0 !border-b  rounded-[3px] !shadow-none div-dropdown ${className ? className : ""
          }`}
      />
    </div>
  );
}
